import React, { useReducer, useEffect, useContext} from "react";
import eppContext from "./eppContex";
import { getAllEpp, addEpp, updateEpp, deleteEpp } from "../../api/epp";
import eppReducer from "./eppReducer";
import authContext from "../authentication/authContex";

//Types
import {
    ACTUALIZAR_LIST_EPP,
  } from "./eppActions";
import { SocketContext } from "../socket/socket";

const EppState = props =>{

    const initialState = {
        eppIDLista: []
     };

    const [state, dispatch] = useReducer(eppReducer, initialState);
    const server = useContext(SocketContext);
    const auContext = useContext(authContext);
    const {usuario, verificarTenant} = auContext;

    const actualizarEppLista = async () => {
        try{
            const resp = await getAllEpp();
            const epp = resp.data.data;
            dispatch({
                type: ACTUALIZAR_LIST_EPP,
                payload: epp
            });
            return epp;
        }catch(err){
            console.log(err)
        }
    };

    const agregarEpp = async (dato) => {
        try{
            const resp = await addEpp(dato);
            const epp = resp.data.data;
            return epp;
        }catch(err){
            console.log(err);
            return null;
        }
    };

    const modificarEpp = async (dato) => {
        try{
            const resp = await updateEpp(dato);
            const epp = resp.data.data;
            return epp;
        }catch(err){
            console.log(err)
            return null;
        }
    }

    const eliminarEpp = async (id, tDocID) => {
        try{
            const resp = await deleteEpp(id, tDocID);
            return resp;
        }catch(err){
            console.log(err)
        }
    }

    useEffect(() => {
        if(usuario != null) actualizarEppLista();
    },[usuario])

    useEffect(()=>{
            if(server){
                server.on('eppsEdited', ({tenantId}) =>{
                    console.log("Recibo el evento del Real Time Server eppsEdited");
                    const verification = verificarTenant(tenantId)
                    if(verification){
                        actualizarEppLista();
                    }
                })
                return () => {
                    server.off('eppsEdited');
                }
            }
        },[server])

    return(
        <eppContext.Provider
            value={{
                eppIDLista: state.eppIDLista,
                actualizarEppLista,
                agregarEpp,
                modificarEpp,
                eliminarEpp
            }}
        >
            {props.children}
        </eppContext.Provider>
    )

}

export default EppState;
